/* eslint-disable react/prop-types, react/destructuring-assignment */
import objectPath from 'object-path'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { BS_THEME_CHANGE_EVENT } from '../../../app/util/colorScheme'
import KTToggle from '../../_assets/js/toggle'
import * as builder from '../../ducks/builder'
import { getLandingPagePath } from '../../utils/utils'
import { ReactComponent as AngleDoubleLeftIcon } from '../assets/layout-svg-icons/Angle-double-left.svg'
import { ReactComponent as AngleDoubleRightIcon } from '../assets/layout-svg-icons/Angle-double-right.svg'

class Brand extends React.Component {
  ktToggleRef = React.createRef()

  constructor(props) {
    super(props)
    this.state = { bsThemeToken: 0 }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener(BS_THEME_CHANGE_EVENT, this.onBsThemeChange)
    }
    // eslint-disable-next-line no-new
    new KTToggle(this.ktToggleRef.current, this.props.toggleOptions)
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener(BS_THEME_CHANGE_EVENT, this.onBsThemeChange)
    }
  }

  onBsThemeChange = () => {
    this.setState((s) => ({ bsThemeToken: s.bsThemeToken + 1 }))
  }

  render() {
    const landingPagePath = getLandingPagePath(this.props.permissions)

    return (
      <div className={`aside__brand grid__item ${this.props.brandClasses}`} id="aside_brand">
        <div className="aside__brand-logo">
          <Link to={landingPagePath}>
            <img
              key={this.state.bsThemeToken}
              className="img-fluid"
              alt="logo"
              src={builder.resolveLayoutLogoUrl(this.props.layoutConfig)}
            />
          </Link>
        </div>

        {this.props.asideSelfMinimizeToggle && (
          <div className="aside__brand-tools">
            <button type="button" ref={this.ktToggleRef} className="aside__brand-aside-toggler" id="aside_toggler">
              <span>
                <AngleDoubleLeftIcon />
              </span>
              <span>
                <AngleDoubleRightIcon />
              </span>
            </button>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  document.querySelector("link[id='favicon']").href = builder.selectors.getFavicon(store)

  return {
    brandClasses: builder.selectors.getClasses(store, {
      path: 'brand',
      toString: true,
    }),
    asideSelfMinimizeToggle: objectPath.get(store.builder.layoutConfig, 'aside.self.minimize.toggle'),
    layoutConfig: store.builder.layoutConfig,
    headerStickyLogo: builder.selectors.getStickyLogo(store),
    toggleOptions: {
      target: 'body',
      targetState: 'aside--minimize',
      togglerState: 'aside__brand-aside-toggler--active',
    },
    permissions: store.userPermissions.data.permissions,
  }
}

export default connect(mapStateToProps)(Brand)
